import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import WPAccordionGroup from "../../../packages/WPAccordionGroup/WPAccordionGroup";
import WPHeading from "../../../packages/WPHeading";

import { CheckIcon } from "../../../assets/icons";

import "./LicensePermissionsAccordion.scss";

const groupLicensePermissionsByCategory = (permissions = []) =>
  (permissions || []).reduce((acc, permission) => {
    const category = permission?.category || "Other";
    // Exclude technology section for now, since we have only RO
    if (category.toLowerCase() !== "technology") {
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(permission?.name || "-");
    }
    return acc;
  }, {});

const LicensePermissionsAccordion = ({ licenseObj }) => {
  const { t } = useTranslation();

  const groupedPermissions = useMemo(
    () =>
      groupLicensePermissionsByCategory(licenseObj?.licensePermissions || []),
    [licenseObj],
  );

  const description = (
    <>
      <WPHeading
        size="xSmall"
        type="default"
        className="permissions-expiry-text"
        text={t("licenseManagement.licenseExpiryText")}
        wrapContent={false}
        secondary
        fontNoto
      />
      <div className="license-permission-categories">
        {Object.entries(groupedPermissions).map(([category, items]) => (
          <div className="license-permission-category" key={category}>
            <WPHeading
              text={category}
              type="default"
              size="small"
              className="permission-category-title"
              fontNoto
            />
            <div className="permission-list-inline">
              {items.map((item, idx) => (
                <span className="permission-item">
                  <CheckIcon />
                  <span
                    className="permission-item-text"
                    key={`${category}-${idx}`}
                  >
                    {item}
                  </span>
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );

  if (!licenseObj) {
    return null;
  }

  return (
    <div className="license-permissions-section">
      <WPAccordionGroup
        data={[
          {
            title: (
              <WPHeading
                text={t("licenseProfile.licensePermissions")}
                className="permissions-text"
                type="default"
                size="small"
                fontNoto
                id="license_accordion_expand"
              />
            ),
            description,
          },
        ]}
      />
    </div>
  );
};

export default LicensePermissionsAccordion;
